import {
  NL_SEARCH_QUOTA_EXCEEDED_CODE,
  NL_SEARCH_QUOTA_EXCEEDED_FALLBACK_MESSAGE,
} from '../data/nlSearchConstants';

/**
 * ¿El envelope de `/parsesearchquery` es el 429 de cupo diario NL?
 * Un 429 sin ese `code` (throttling del Gateway) no es cupo.
 * @param {object|null|undefined} envelope - Respuesta de `httpClient`.
 * @returns {boolean}
 * @see docs/maps/natural-language-search.md
 */
export const isNlSearchQuotaExceeded = (envelope) => (
  envelope?._httpStatus === 429 && envelope?.code === NL_SEARCH_QUOTA_EXCEEDED_CODE
);

/**
 * Texto para el usuario: el `error` de la API si viene, si no un fallback propio.
 * @param {object|null|undefined} envelope
 * @returns {string}
 */
export const getNlSearchQuotaMessage = (envelope) => {
  const apiMessage = typeof envelope?.error === 'string' ? envelope.error.trim() : '';
  return apiMessage || NL_SEARCH_QUOTA_EXCEEDED_FALLBACK_MESSAGE;
};
